import GenersGridContainer from "./GenersOld/GenersGridContainer";

export default function NoData () {
    return (
        <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '200px',
          backgroundColor: '#f5f5f5',
          borderRadius: '8px',
        }}
      >
        <p
          style={{
            fontSize: '18px',
            color: '#999',
            margin: 0,
          }}
        >
          No data available
        </p>
      </div>
      );
}